<template>
    <b-form @submit="onSubmit" autocomplete="off">
        <!-- Page title -->
        <b-row>
            <b-col md="12">
                <h3 class="text-themecolor">{{$t('management.groep')}}<span v-if="command.id" class="pl-2">{{$t('klantrelaties.bewerker')}}</span><span v-else>{{$t('klantrelaties.aanmaker')}}</span></h3>
            </b-col>
        </b-row>
        <!-- Page title -->

        <!-- Form content -->
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <b-form-group class="mb-3" label-cols :label="$t('datatables.naam')">
                            <b-form-input v-model="command.name" type="text" :placeholder="$t('datatables.naam')" />
                            <validation element="name" />
                        </b-form-group>
                        <b-form-group class="mb-3" label-cols :label="$t('management.rechten')" label-for="permissions">
                            <treeselect v-model="valuePermissions" :alwaysOpen="false" :multiple="true" :autoFocus="true" :options="optionsPermissions" :load-options="loadOptionsPermissions"/>
                            <validation element="permissions" />
                        </b-form-group>
                        <b-form-group class="mb-3" label-cols :label="$t('datatables.gebruikers')" label-for="users">
                            <treeselect v-model="valueUsers" :alwaysOpen="false" :multiple="true" :options="optionsUsers" :load-options="loadOptionsUsers"/>
                            <validation element="users" />
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Form content -->

        <!-- Submit controls -->
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
    </b-form>
</template>
<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'

// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

//Import store
import { mapActions, mapGetters } from 'vuex'

//Import command
import Command from './command'

export default {
    name: 'groups-form',
    components: { Treeselect },
    data() {
        return {
            command: new Command(),
            valuePermissions: null,
            optionsPermissions: [
                {
                    id: 'all',
                    label: this.$i18n.t('management.alleRechten'),
                    children: []
                }
            ],            
            valueUsers: null,
            optionsUsers: [
                {
                    id: 'all',
                    label: this.$i18n.t('management.alleGebruikers'),
                    children: []
                }
            ],            
        }
    },
    computed: {
        ...mapGetters('core',['group', 'permissions', 'users']),
    },
    methods: {
        ...mapActions('core',['all','create','update', 'find']),
        onSubmit(event) {
            event.preventDefault();
            const vm = this;
            vm.command.permissionIds = [];
            vm.command.userIds = [];

            if(vm.valuePermissions) 
            {
                if(vm.valuePermissions.indexOf("all") !== -1) {
                    vm.command.accessToEverything = true;
                }
                else {
                    vm.command.accessToEverything = false;
                    vm.valuePermissions.forEach((id) => {
                        vm.command.permissionIds.push(id);
                    });
                }
            }
            else {
                vm.command.accessToEverything = false;
            }

            if(vm.valueUsers) 
            {
                if(vm.valueUsers.indexOf("all") !== -1) {
                    vm.command.availableForEveryOne = true;
                }
                else {
                    vm.command.availableForEveryOne = false;
                    vm.valueUsers.forEach((id) => {
                        vm.command.userIds.push(id);
                    });
                }
            }
            else {
                vm.command.availableForEveryOne = false;
            }

            var payload = {
                resource: 'groups',
                params: vm.command
            };
            if(vm.command.id) {
                vm.update(payload)
                .then(()=> {
                    vm.find({
                        resource: 'groups', 
                        id: vm.$route.params.groupId
                    });

                    vm.$router.push({ name: 'groups:detail', params: { groupId: vm.group.id, permissions: vm.group.permissions, users: vm.group.users } });
                });
            }
            else {
                vm.create(payload)
                .then(() => {
                    vm.goTo('index');
                });
            }
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `groups:${name}` });
        },
        loadOptionsPermissions({ callback }) {
            callback();
        },
        loadOptionsUsers({ callback }) {
            callback();
        }
    },
    created() {
        const vm = this;

        vm.all({
            resource: 'permissions'
        }).then((permissionsResult) => {
            vm.valuePermissions = [];
            if(vm.command.accessToEverything) {
                vm.valuePermissions = ['all'];
            }

            permissionsResult.result.forEach((permission) =>
            {
                let permissionOption = {
                    id: permission.id,
                    label: permission.name
                }

                vm.optionsPermissions[0].children.push(permissionOption);
            })

            if(!vm.command.accessToEverything && vm.command.permissionIds !== null) {
                let permissionIds = vm.command.permissionIds
                let allIndex = vm.valuePermissions.indexOf('all');
                
                if(allIndex > -1) {
                    vm.valuePermissions.splice( allIndex, 1 );
                }

                permissionIds.forEach( (permissionId) => {
                    vm.valuePermissions.push(permissionId);
                })
            }
        });

        vm.all({
            resource: 'users'
        }).then((usersResult) => {
            vm.valueUsers = [];
            if(vm.command.availableForEveryOne) {
                vm.valueUsers = ['all'];
            }

            usersResult.result.forEach((user) =>
            {
                let userOption = {
                    id: user.id,
                    label: user.fullName
                }

                vm.optionsUsers[0].children.push(userOption);
            })

            if(!vm.command.availableForEveryOne && vm.command.userIds !== null) {
                let userIds = vm.command.userIds
                let allIndex = vm.valueUsers.indexOf('all');
                
                if(allIndex > -1) {
                    vm.valueUsers.splice( allIndex, 1 );
                }

                userIds.forEach( (userId) => {
                    vm.valueUsers.push(userId);
                })
            }
        });

        if(vm.$route.name.split(':')[1] == 'update') {
            const item = vm.group;

            if(!item.id) {
                vm.goTo('detail');
            }
            else {
                vm.command = new Command(item);
            }
        }
    }
}
</script>